import ServicePage from "../components/site/ServicePage";
import { getService } from "../data/site";

const TASKS = [
  "Full cleaning",
  "Fresh linens",
  "Bed making",
  "Kitchen reset",
  "Bathroom reset",
  "Restocking essentials",
  "Refrigerator clean out",
  "Trash removal",
  "Guest-ready styling",
  "Damage reporting",
  "Photos on request",
];

export default function RentalTurnovers() {
  return (
    <ServicePage
      service={getService("rental-turnovers")}
      tagline="A five-star welcome, every single guest."
      intro="For Airbnb and vacation rental owners on the South Shore, we make every turnover feel effortless — a spotless, styled, restocked home your guests will rave about, with reliable communication you can count on."
      tasksTitle="Every turnover includes"
      tasks={TASKS}
      quoteHeading="Request a Quote"
    />
  );
}
